import { requests } from "../../../api/agent"

export default {
	create       		 	   : (params) => requests.post('/constructor/createProject', params),
	edit       		 	   	   : (params) => requests.post('/constructor/EditById', params),
	getAllPriceByProjectId     : (params) => requests.getWithParams('/constructor/getAllPriceByProjectId', params),
	getAllPriceByObjectId      : (params) => requests.getWithParams('/aObject/getAllPriceByObjectId', params),
	getPagePriceByProjectId    : (params) => requests.getWithParams('/constructor/getPagePriceByProjectId', params),
	getAllPtmByProjectId       : (params) => requests.getWithParams('/constructor/getAllPtmByProjectId', params),
	getUserProjects       	   : (params) => requests.getWithParams('/constructor/getUserProjects', params),
	getUserProject       	   : (params) => requests.getWithParams('/constructor/getById/' + params),
	getAllPtmByObjectId        : (params) => requests.getWithParams('/aObject/getAllPtmByObjectId', params),
	getPageObjectByCode2	   : (params) => requests.getWithParams('/aObject/getPageObjectsByCode2', params),
	getPageObjectByCode3	   : (params) => requests.getWithParams('/aObject/getPageObjectsByCode3', params),
	getPageObjectByCode4	   : (params) => requests.getWithParams('/aObject/getPageObjectsByCode4', params),
	postAnalogObjStatisticData : (params) => requests.post('/aObject/getAnalogObjectAvg', params)
}
